import { defineMessages } from 'react-intl';

export const activityGridMessages = defineMessages({
  columnDateTime: {
    description: 'Column header for date and time in the product activity grid',
    defaultMessage: 'Date / Time',
    id: 'C5DhO7',
  },
  columnActivity: {
    description: 'Column header for activity description in the product activity grid',
    defaultMessage: 'Activity',
    id: 'rcGFcR',
  },
  columnUser: {
    description: 'Column header for user name in the product activity grid',
    defaultMessage: 'User',
    id: 'Lf5KVK',
  },
  noActivityRecordsTitle: {
    description: 'Empty state title when there are no activity records for the product',
    defaultMessage: 'No activity records found.',
    id: 'KZA3Ex',
  },
  noActivityRecordsDescription: {
    description: 'Empty state description when there are no activity records for the product',
    defaultMessage: 'Activity will appear here once changes are made to this product.',
    id: 'PR6QD9',
  },
});
